<template>
  <div class="page-home">
    <div class="search-wrap" v-show="false">
      <div class="search-input" @click="handleClickSearch()">
        <img class="ic-search" :src="searchIcon" />
        <span class="search-hint">搜索商品标题、关键字</span>
      </div>
    </div>
    <!-- tab菜单 -->
    <div class="tab-wrap">
      <div class="tab-list">
        <md-tab-bar ref="homeTabbar" v-model="curTabId" :items="tabList" :maxLength="5" :ink-length="70" @change="handleChangeTab" />
      </div>
      <div class="tab-button" @click="handleClickGoCatePage()" v-if="false">
        <img class="ic-cate" :src="cateIcon" />
      </div>
    </div>
    <div class="tabPage-swiper">
      <md-swiper
        ref="homeSwiper"
        :autoplay="0"
        :is-prevent="false"
        :is-loop="false"
        :has-dots="false"
        :useNative-driver="false"
        :default-index="curSwiperIndex"
        @before-change="handleSwiperChange"
      >
        <md-swiper-item :ref="`tabSwiperItem_${tabItem.tabId}`" v-for="tabItem in tabList" :key="tabItem.tabId">
          <TabPage
            :ref="`tabPage_${tabItem.tabId}`"
            :curTabId="curTabId"
            :tabId="tabItem.tabId"
            :isHomePage="tabItem.rule !== '' && tabItem.rule.isHomePage === 1"
            :bannerHeight="bannerHeight"
            :cateColumnWidth="cateColumnWidth"
            :channel="channel"
          />
        </md-swiper-item>
      </md-swiper>
    </div>
  <JdTabs />
  </div>
</template>

<script>
import { TabBar, Swiper, SwiperItem } from 'mand-mobile'
import TabPage from '@/components/tabPage'
import { rem2px } from '@/utils/help'
import JdTabs from '@/components/jdTabs'
export default {
  name: 'home',
  components: {
    TabPage,
    JdTabs,
    [TabBar.name]: TabBar,
    [Swiper.name]: Swiper,
    [SwiperItem.name]: SwiperItem,
  },
  data() {
    return {
      channel: 'jd',
      searchIcon: require('../../assets/ic_search.png'),
      cateIcon: require('../../assets/ic_home_category.png'),
      curTabId: 0, // 当前tabId
      curSwiperIndex: 0, // 当前swiper索引
      tabList: [],
      bannerHeight: 0,
      cateColumnWidth: 0,
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      let AlivePages = ['productList', 'productDetail', 'cate', 'jdSearch', 'jdMine']
      if (from.name === null || AlivePages.indexOf(from.name) === -1) {
        vm.initData()
      }
    })
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      this.curTabId = 0
      this.curSwiperIndex = 0
      this.tabList = []
      this.initSize()
      this.fetchTabList()
    },
    initSize() {
      this.initElementWidth()
      window.onresize = () => {
        this.initElementWidth()
      }
    },
    /**
     * 初始化分类菜单item的宽度, 以及轮播图的高度
     */
    initElementWidth() {
      let winW = window.innerWidth || document.body.clientWidth // 屏幕宽度
      const winH = window.innerHeight || document.body.clientHeight // 屏幕高度
      this.cateColumnWidth = (winW - 30) / 5
      this.bannerHeight = ((winW - rem2px(0.6)) * 300) / 750
    },
    /**
     * tab菜单
     */
    fetchTabList() {
      this.$http.jd.tabList().then(res => {
        for (let item of res.data) {
          item.name = item.tabId
          item.label = item.tabName
        }
        this.tabList = res.data
        this.curTabId = this.tabList[0].tabId
        this.refreshTabData()
      })
    },
    /**
     * 手动切换tab
     */
    handleChangeTab(item, index, prevIndex) {
      if (this.curTabId !== item.name) {
        this.curTabId = item.name
        this.$refs.homeSwiper.goto(index)
      }
    },
    /**
     * swiper切换监听
     */
    handleSwiperChange(from, to) {
      this.curSwiperIndex = to
      this.curTabId = this.tabList[to].tabId
      this.refreshTabData()
    },
    /**
     * 刷新tab数据
     */
    refreshTabData() {
      if (this.curTabId > 0) {
        this.$nextTick(() => {
          const tabVM = this.getTabVM()
          if (tabVM) {
            if (!tabVM.isInit) {
              tabVM.init()
            } else {
              tabVM.scroll2Pos(0)
            }
          }
        })
      }
    },
    /**
     * 获取tab的DOM元素
     */
    getTabVM() {
      const tabVM_Arr = this.$refs[`tabPage_${this.curTabId}`]
      if (tabVM_Arr && tabVM_Arr[0]) {
        return tabVM_Arr[0]
      }
      return null
    },
    /**
     * 点击搜索
     */
    handleClickSearch() {
      this.$router.push({ name: 'search', query: { channel: this.channel } })
    },
    /**
     * 点击跳转分类页面
     */
    handleClickGoCatePage() {
      this.$router.push({ name: 'cate', query: { channel: this.channel } })
    },
  },
}
</script>

<style lang="scss" scoped>
.page-home {
  position: relative;
  overflow: hidden;
  height: 100%;
  background: #fff;
  .search-wrap {
    height: 0.8rem;
    background: #fff;
    padding: 0 0.6rem;
    .search-input {
      height: 0.64rem;
      line-height: 0.64rem;
      background: #f4f4f4;
      border-radius: 0.64rem;
      display: flex;
      align-items: center;
      padding-left: 0.3rem;
      cursor: pointer;
      .ic-search {
        display: inline-block;
        width: 0.26rem;
        height: 0.27.7333333rem;
        margin-right: 0.12rem;
      }
      .search-hint {
        margin-top: 0.04rem;
        display: inline-block;
        font-size: 0.24rem;
        color: rgba(0, 0, 0, 0.3);
      }
    }
  }
  .tab-wrap {
    position: relative;
    height: 0.7rem;
    background: #fff;
    .tab-list {
      position: absolute;
      top: 0;
      left: 0;
      // right: 0.8rem;
      right: 0;
      height: 0.7rem;
      .md-tab-bar {
        padding-left: 0.1rem;
        padding-right: 0;
      }
    }
    .tab-button {
      position: absolute;
      right: 0;
      top: -0.05rem;
      height: 0.7rem;
      width: 0.8rem;
      text-align: center;
      .ic-cate {
        width: 0.8rem;
        height: 0.6833333rem;
      }
    }
  }
  .tabPage-swiper {
    position: absolute;
    top: 0.8rem;
    bottom: 1rem;
    left: 0;
    right: 0;
  }
}
</style>
